export default "__VITE_ASSET__7b121b47__"